/* eslint-disable jsx-a11y/control-has-associated-label */
import cx from 'classnames';
import React, { Children, useCallback, useEffect, useRef, useState } from 'react';
import { PlanNavigation } from 'src/components/LandingPage/ServicePlans/components/PlanNavigation';
import * as classes from 'src/components/LandingPage/ServicePlans/ServicePlans.module.scss';
import useTheme from 'src/hooks/useTheme';
import { useWindowResize } from 'src/hooks/useWindowResize';

export const ServicePlansHeader = ({ onPlanSelect, plans, isMobileView, currentPlanIndex, highlightedPlanIndex }) => {
  const [planNameHeight, setPlanNameHeight] = useState(null);
  const planRowRef = useRef(null);
  const t = useTheme();

  const highlightClass = t.theme === 'cheppersHU' ? classes.highlightedHU : classes.highlighted;
  const calculatePlanHeights = useCallback(() => {
    if (planRowRef.current) {
      const heights = [];
      for (let i = 1; i < 4; i += 1) {
        heights.push(planRowRef.current.cells[i].children[0].clientHeight);
      }
      setPlanNameHeight(Math.max(...heights));
    }
  }, [planRowRef]);

  useWindowResize(calculatePlanHeights);

  useEffect(() => {
    calculatePlanHeights();
  }, [calculatePlanHeights]);

  return (
    <thead>
      <tr
        style={{
          height: planNameHeight ? `${planNameHeight}px` : undefined,
        }}
        ref={planRowRef}
      >
        <th
          style={{
            border: 'none',
          }}
          className={classes.placeholderHeading}
        />
        {Children.toArray(
          plans.map(({ name, targetAudience }, i) => (
            <th
              className={cx({
                [classes.planBeforePreviousPlan]: i < currentPlanIndex - 1,
                [classes.previousPlan]: i === currentPlanIndex - 1,
                [classes.currentPlan]: i === currentPlanIndex,
                [classes.nextPlan]: i === currentPlanIndex + 1,
                [classes.planAfterNextPlan]: i > currentPlanIndex + 1,
                [classes.planContainer]: true,
              })}
            >
              <div
                onClick={() => onPlanSelect(i)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    onPlanSelect(i);
                  }
                }}
                role="button"
                tabIndex={i + 1}
                style={{
                  height: planNameHeight ? `${planNameHeight}px` : undefined,
                  cursor: 'default',
                }}
                className={cx({
                  [classes.planTitleContainer]: true,
                  [highlightClass]: i === highlightedPlanIndex,
                })}
              >
                <div className={classes.brandTagline}>cheppers</div>
                <div className={classes.planName}>{name}</div>
                <div className={classes.targetAudienceLabel}>{targetAudience}</div>
              </div>
            </th>
          ))
        )}
      </tr>
      <tr className={classes.subtitle}>
        <td colSpan={plans.length + 1}>
          <div style={{ position: 'relative' }}>
            {isMobileView && (
              <div className={classes.navigationOffset}>
                <PlanNavigation plans={plans} onPlanSelect={onPlanSelect} currentPlanIndex={currentPlanIndex} />
              </div>
            )}
            {t.theme === 'cheppersHU' ? 'Cheppers AWS menedzselt szolgáltatások' : 'Cheppers AWS Managed services'}
          </div>
        </td>
      </tr>
    </thead>
  );
};
